"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function NativeworkloadsGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__nativeworkloads-green-multitone-filled__clip0_17144_4382)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M10.6.794c-1.548 0-2.977.834-3.811 2.223a.334.334 0 01-.278.16c-.119.039-.238 0-.318-.08a2.185 2.185 0 00-1.39-.477c-1.23 0-2.262 1.072-2.262 2.343 0 .595.198 1.151.595 1.588.08.119.12.278.08.397-.04.159-.199.238-.358.238-1.15.12-2.064 1.151-2.064 2.382 0 1.31 1.032 2.343 2.263 2.343h4.764V9.568c0-.873.715-1.588 1.588-1.588h.516c.199-.437.596-.715 1.072-.715h4.09V4.844c0-2.343-1.906-4.05-4.487-4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M7.821 11.91H3.057c-1.23 0-2.263-1.032-2.263-2.342 0-1.23.913-2.263 2.104-2.342.16 0 .278-.12.358-.238.04-.16.04-.318-.08-.397a2.323 2.323 0 01-.595-1.589c0-1.31 1.032-2.342 2.263-2.342.516 0 .953.159 1.39.476.079.04.158.08.277.04.12 0 .238-.08.278-.159.834-1.39 2.263-2.223 3.812-2.223 2.58 0 4.486 1.707 4.486 4.05v2.422h.476c.12 0 .199 0 .318.04V4.843C15.88 2.024 13.658 0 10.6 0 8.893 0 7.345.834 6.352 2.223a2.862 2.862 0 00-1.508-.397c-1.668 0-3.057 1.43-3.057 3.137 0 .556.158 1.111.397 1.588C.914 6.948 0 8.139 0 9.568c0 1.747 1.39 3.137 3.057 3.137H7.821v-.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M9.867 14.491h-.909c-.188 0-.343-.357-.343-.794V9.568c0-.436.155-.794.343-.794h.909v5.717zM15.563 15.206h-4.526a.398.398 0 01-.397-.397V8.457c0-.239.159-.397.397-.397h4.566c.238 0 .397.158.397.397v6.352c-.04.199-.199.397-.437.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M15.166 8.854v5.558h-3.771V8.854h3.771zm.397-.794h-4.526c-.238 0-.397.158-.397.397v6.352c0 .238.159.397.397.397h4.566a.398.398 0 00.397-.397V8.457c-.04-.199-.199-.397-.437-.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M11.394.873c-.277-.04-.516-.08-.794-.08-1.548 0-2.977.835-3.811 2.224a.334.334 0 01-.278.16c-.119.039-.238 0-.318-.08a2.156 2.156 0 00-1.35-.477c-1.23 0-2.262 1.072-2.262 2.343 0 .595.198 1.151.595 1.588.08.119.12.278.08.397-.04.119-.199.238-.358.238-1.19.12-2.104 1.151-2.104 2.382 0 .596.198 1.112.556 1.549L11.394.873z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M13.575 3.606c0-1.673-1.874-3.101-2.935-3.606 3.788.113 5.367 2.846 5.263 4.974v2.282h-2.24c0-.505-.088-1.977-.088-3.65z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__nativeworkloads-green-multitone-filled__clip0_17144_4382"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

NativeworkloadsGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
NativeworkloadsGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = NativeworkloadsGreenMultitoneFilled;
exports["default"] = _default;